import Vue from 'vue'
import Router from 'vue-router'

// Frontend

//  - products
import Home from '@/components/frontend/Home'
import Cms from '@/components/common/Cms'
import E404 from '@/components/common/E404'
import Product from '@/components/frontend/products/Product'
import Products from '@/components/frontend/products/Products'

//  - user
import Login from '@/components/frontend/profiles/Login'
import Register from '@/components/frontend/profiles/Register'
import ForgetPass from '@/components/frontend/profiles/ForgetPass'
import ResetPass from '@/components/frontend/profiles/ResetPass'
import Logout from '@/components/frontend/profiles/Logout'
import Profile from '@/components/frontend/profiles/Profile'
import AddressChange from '@/components/frontend/profiles/AddressChange'
import UserBidsPage from '@/components/frontend/profiles/UserBidsPage'
import UserPayResponse from '@/components/frontend/profiles/UserPayResponse'
import UserPayTransfer from '@/components/frontend/profiles/UserPayTransfer'
import UserPayMessage from '@/components/frontend/profiles/UserPayMessage'

// Backend
import ProductUpload from '@/components/backend/products/ProductUpload'
import ProductsOrder from '@/components/backend/products/ProductsOrder'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home,
			meta: {
				requiresAuth: false,
			},
		},
		{
			path: '/site/:path',
			name: 'Cms',
			component: Cms,
			meta: {
				requiresAuth: false,
				title: 'HTaukcio',
			},
		},
		{
			path: '/products',
			name: 'Products',
			component: Products,
			props: true,
			meta: {
				requiresAuth: false,
			},
		},
		{
			path: '/products/:maincategory',
			name: 'ProductsByCategory',
			props: true,
			component: Products,
			meta: {
				requiresAuth: false,
			},
		},
		{
			path: '/login',
			name: 'Login',
			component: Login,
			meta: {
				requiresAuth: false,
			},
		},
		{
			path: '/register',
			name: 'Register',
			component: Register,
			meta: {
				requiresAuth: false,
			},
		},
		{
			path: '/forgetPass',
			name: 'ForgetPass',
			component: ForgetPass,
			meta: {
				requiresAuth: false,
			},
		},
		{
			path: '/resetPass',
			name: 'ResetPass',
			component: ResetPass,
			meta: {
				requiresAuth: false,
			},
		},
		{
			path: '/logout',
			name: 'Logout',
			component: Logout,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/product/:id',
			name: 'Product',
			props: true,
			component: Product,
			meta: {
				requiresAuth: false,
			},
		},
		{
			path: '/profile/mybids',
			name: 'UserBidsPage',
			component: UserBidsPage,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/profile/address',
			name: 'AddressChange',
			component: AddressChange,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/profile/mybids/:page',
			name: 'UserBidsPageTab',
			component: UserBidsPage,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/profile/paid/:type',
			name: 'UserPayResponse',
			component: UserPayResponse,
			meta: {
				requiresAuth: true,
				hideMenu: true,
				hideFooter: true,
			},
		},
		{
			path: '/profile/transfer/:type',
			name: 'UserPayTransfer',
			component: UserPayTransfer,
			meta: {
				requiresAuth: true,
				hideMenu: true,
				hideFooter: true,
			},
		},
		{
			path: '/profile/pay/:type/:order_id',
			name: 'UserPayMessage',
			component: UserPayMessage,
			meta: {
				requiresAuth: false,
				hideMenu: true,
				hideFooter: true,
			},
		},
		{
			path: '/profile',
			name: 'Profile',
			component: Profile,
			meta: {
				requiresAuth: true,
			},
		},
		// {
		//   path: '/product-admin',
		//   name: 'admin',
		//   component: Admin,
		//   meta: {
		//     requiresAuth: true,
		//     admin: true
		//   },
		// },
		// {
		//   path: '/product-admin/products',
		//   name: 'ProductAdminList',
		//   component: ProductAdminList,
		//   meta: {
		//     requiresAuth: true,
		//     admin: true
		//   },
		// },
		{
			path: '/product-admin/products-order/:auction_id',
			name: 'ProductsOrder',
			component: ProductsOrder,
			meta: {
				requiresAuth: true,
				admin: true,
			},
		},
		// {
		//   path: '/product-admin/bids/:id/',
		//   name: 'ProductBids',
		//   component: ProductBids,
		//   meta: {
		//     requiresAuth: true,
		//     admin: true
		//   },
		// },
		{
			path: '/product-admin/product-upload',
			name: 'ProductUpload',
			component: ProductUpload,
			meta: {
				requiresAuth: true,
				admin: true,
			},
		},
		{
			path: '/product-admin/product-upload/:product_id',
			name: 'ProductEdit',
			component: ProductUpload,
			meta: {
				requiresAuth: true,
				admin: true,
			},
		},
		// {
		//   path: '/product-admin/auctions',
		//   name: 'Auctionlist',
		//   component: Auctionlist,
		//   meta: {
		//     requiresAuth: true,
		//     admin: true
		//   },
		// },
		{ path: '*', component: E404 },
	],
	scrollBehavior() {
		return { x: 0, y: 0 }
	}

})

export default router
